import { CODE_NAME_SEPARATOR, HIERARCHY_SEPARATOR } from './separators';

/**
 * コードと名称を結合して表示用文字列を生成
 */
export const connectCodeAndName = ({
  name,
  code,
}: {
  name: string;
  code: string;
}): string | null => {
  if (!code) {
    return name;
  }
  if (!name) {
    return null;
  }
  return `${code}${CODE_NAME_SEPARATOR}${name}`;
};

type IdAndName = {
  code: string;
  name: string;
};

/**
 * 事業名を款・項・目・事業コード/名称から生成
 */
export const connectProjectName = ({
  kan,
  ko,
  moku,
  project_name,
  project_code,
}: {
  kan: IdAndName;
  ko: IdAndName;
  moku: IdAndName;
  project_name: string;
  project_code: string;
}) => {
  return [
    connectCodeAndName({ name: kan.name, code: kan.code }),
    connectCodeAndName({ name: ko.name, code: ko.code }),
    connectCodeAndName({ name: moku.name, code: moku.code }),
    connectCodeAndName({
      name: project_name,
      code: project_code,
    }),
  ]
    .filter(Boolean)
    .join(HIERARCHY_SEPARATOR);
};
